
import { Utils } from "../../utils.js";
import { MeasurePanel } from "./MeasurePanel.js";

export class AnnotationPanel extends MeasurePanel {
  constructor(viewer, measurement, propertiesPanel) {
    super(viewer, measurement, propertiesPanel);

    this.annotation = measurement;
    let removeIconPath = Potree.resourcePath + '/icons/remove.svg';

    const t = (key, fallback) => (typeof i18n !== 'undefined') ? i18n.t(key) : fallback;

    this.elContent = $(`
      <div class="measurement_content selectable">
        <span class="coordinates_table_container"></span>

        <div style="margin-top: 10px">
          <div class="measurement_value_table_header">${t('annotations.description', 'Description')}</div>
          <textarea id="annotation_description_input" style="width: 100%; box-sizing: border-box; padding: 5px 6px; font-size: 12px; font-family: var(--font-family); color: var(--sidebar-text); background: transparent; border: 1px solid var(--card-border); border-radius: 4px; min-height: 48px; resize: vertical"></textarea>
        </div>

        <div style="display: flex; margin-top: 12px">
          <span style="flex-grow: 1"></span>
          <img name="remove" class="button-icon" src="${removeIconPath}" style="width: 16px; height: 16px"/>
        </div>
      </div>
    `);

    this.elDescription = this.elContent.find("#annotation_description_input");
    this.elDescription.val(this.annotation.description);
    this.elDescription.on("input", () => {
      this.annotation.description = this.elDescription.val();
    });

    this.elRemove = this.elContent.find("img[name=remove]");
    this.elRemove.click(() => {
      this.viewer.scene.removeAnnotation(this.annotation);
    });

    this.update();
  }

  update() {
    const { annotation, elContent, elDescription } = this;

    let elCoordinatesContainer = elContent.find('.coordinates_table_container');
    elCoordinatesContainer.empty();
    elCoordinatesContainer.append(this.createCoordinatesTable([annotation.position]));

    elDescription.val(annotation.description);
  }
};
